module.exports = __webpack_public_path__ + "static/18-286dfd626efc3d22da9a5c72f4ff4918.jpg";